// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

// This is a utility-attribute for capybara-lockstep
up.compiler('[data-initializing]', (element) => {
  element.removeAttribute('data-initializing')
})
